import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css'; // optional for styling
import 'tippy.js/animations/shift-away-subtle.css';

function initTooltips() {
    tippy('[data-tippy-content]', {
        content: (reference) => reference.getAttribute('data-tippy-content'),
        allowHTML: true,
        animation: 'shift-away-subtle',
    });
}

export default initTooltips;